"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBaseProductFilterFromTableFilter = exports.isCustomProductAttribute = exports.productFieldsToFilterMap = exports.createProductAttributesMeasuresFilter = exports.createProductOriginalAttributesFilter = void 0;
const graphql_1 = require("../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const table_columns_1 = require("../../../common/table-columns");
const client_utils_1 = require("../../../common/table-filter/client.utils");
const attributes_1 = require("../../../constants/attributes");
const createProductOriginalAttributesFilter = (attributeName, filter, operator) => ({
    labels: {
        some: {
            label: {
                equals: attributeName,
            },
            origin: {
                in: [graphql_1.ProductAttributeOrigin.Original],
            },
            value: (0, client_utils_1.createStringFilter)(filter, operator),
        },
    },
});
exports.createProductOriginalAttributesFilter = createProductOriginalAttributesFilter;
const createProductAttributesMeasuresFilter = (attributeName, { low, high }) => ({
    measures: {
        some: {
            dimension: {
                equals: attributeName,
            },
            value: Object.assign(Object.assign({}, low && { gte: Number(low) }), high && { lte: Number(high) }),
        },
    },
});
exports.createProductAttributesMeasuresFilter = createProductAttributesMeasuresFilter;
exports.productFieldsToFilterMap = {
    [attributes_1.CustomProductAttributes.ExternalId]: (filter, operator) => (0, client_utils_1.createExternalIdFilter)(filter, operator),
    [attributes_1.CustomProductAttributes.Name]: client_utils_1.createStringFilter,
    [attributes_1.CustomProductAttributes.CreatedAt]: client_utils_1.createDateTimeFilter,
    [attributes_1.CustomProductAttributes.LastAttributeUpdatedAt]: client_utils_1.createDateTimeFilter,
    [attributes_1.CustomProductAttributes.LastEditedBy]: client_utils_1.createCollaboratorFilter,
    [attributes_1.CustomProductAttributes.LastReviewedBy]: client_utils_1.createCollaboratorFilter,
    [attributes_1.CustomProductAttributes.ClassificationProductType]: client_utils_1.createProductCategoryFilter,
};
const customProductAttributes = Object.values(attributes_1.CustomProductAttributes);
const isCustomProductAttribute = (fieldKey) => (customProductAttributes.includes(fieldKey));
exports.isCustomProductAttribute = isCustomProductAttribute;
/**
 * Builds the common ProductFilter shape for table filters and delegates AI-enriched handling
 * so callers can map that branch either to legacy product attributes or to presentation attributes.
 */
const buildBaseProductFilterFromTableFilter = (tableFilter, resolveAiEnrichedFilter) => {
    const productFilter = {};
    const productAttributesFilter = [];
    tableFilter.items.forEach(({ field: columnId, filter: columnFilter }) => {
        const { type, operator, label: _label } = columnFilter, rawFilterData = __rest(columnFilter, ["type", "operator", "label"]);
        const filterData = rawFilterData;
        const { label: fieldKey, dataMeta: { isMeasure, isAIEnriched } } = (0, table_columns_1.parseColumnId)(columnId);
        if ((0, exports.isCustomProductAttribute)(fieldKey)) {
            if (fieldKey === attributes_1.CustomProductAttributes.ClassificationProductType) {
                productAttributesFilter.push((0, client_utils_1.createProductCategoryFilter)(filterData, operator));
            }
            else if ([
                attributes_1.CustomProductAttributes.LastAttributeUpdatedAt,
                attributes_1.CustomProductAttributes.LastEditedBy,
            ].includes(fieldKey)) {
                const filterFunc = exports.productFieldsToFilterMap[fieldKey];
                productFilter.productMetadata = Object.assign(Object.assign({}, productFilter.productMetadata), { [fieldKey]: filterFunc(filterData, operator) });
            }
            else {
                const filterFunc = exports.productFieldsToFilterMap[fieldKey];
                productFilter[fieldKey] = filterFunc(filterData, operator);
            }
        }
        else if (isMeasure) {
            productAttributesFilter.push((0, exports.createProductAttributesMeasuresFilter)(fieldKey, filterData));
        }
        else if (isAIEnriched) {
            const resolvedFilter = resolveAiEnrichedFilter(fieldKey, filterData, operator);
            if (resolvedFilter) {
                productAttributesFilter.push(resolvedFilter);
            }
        }
        else {
            productAttributesFilter.push((0, exports.createProductOriginalAttributesFilter)(fieldKey, filterData, operator));
        }
    });
    if (!(0, ramda_1.isEmpty)(productAttributesFilter)) {
        productFilter.attributes = productAttributesFilter;
    }
    if (tableFilter.logicOperator === 'or') {
        productFilter.filterStrategy = graphql_1.FilterStrategy.Or;
    }
    return productFilter;
};
exports.buildBaseProductFilterFromTableFilter = buildBaseProductFilterFromTableFilter;
